import React from 'react';
import InfoModal from '../../../../../../components/data-display/InfoModal';
import Paragraph from '../../../../../../components/common/Paragraph';

const DecretoModalLey = () => (
    <InfoModal
        buttonLabel=" Sobre Decreto Ley Nº 3475"
        title="Decreto Ley Nº 3475"
        width={780}
        buttonProps={{ style: { marginTop: '-10px' } }}
    >
        <Paragraph align="justify">
            “El Impuesto de Timbres y Estampillas, se encuentra regulado en el Decreto Ley N° 3.475, de 1980, y es un tributo que grava principalmente los documentos o actos que dan cuenta de una operación de crédito de dinero.
            Su base imponible corresponde al monto del capital especificado en cada documento.


            “El Impuesto de Timbres y Estampillas, se encuentra regulado en el Decreto Ley N° 3.475, de 1980, y es un tributo que grava principalmente los documentos o actos que dan cuenta de una operación de crédito de dinero. Su base imponible corresponde al monto del capital especificado en cada documento.

            Existen tasas fijas y tasas variables. Las letras de cambio, pagarés, créditos simples o documentarios, entrega de facturas o cuentas en cobranza, descuento bancario de letras, préstamos y cualquier otro documento, incluso los que se emitan en forma desmaterializada, que contengan una operación de crédito de dinero, están afectos a una tasa de 0,066% sobre su monto por cada mes o fracción de mes que media entre su fecha de emisión y vencimiento, con un máximo de 0,8%.

            Asimismo, los instrumentos a la vista o sin plazo de vencimiento tienen una tasa de 0,332% sobre su monto.

            En virtud del Decreto Supremo N° 537 Exento del Ministerio de Hacienda, publicado en el Diario Oficial de 04.01.2016, las tasas fijas del Impuesto de Timbres y Estampillas establecidas en los artículos 1°, N° 1, y 4°, se reajustaron en un 2,7% a partir del 01 de enero del 2016, quedando su monto en $3.565.

            Renovación o prórroga de documentos que se gravan conforme al artículo 2° de DL N° 3475:
            <ol>
                <li>Renovación o prórroga con plazo de vencimiento: 0,066% por cada mes completo que se pacte entre el vencimiento original del documento o el vencimiento estipulado en la última renovación o prórroga, según corresponda, y el nuevo vencimiento estipulado en la renovación o prórroga de que se trate.</li>
                <li>Renovación o prórroga sin estipular plazo de vencimiento: 0,332%.</li>
                <li>Tasa máxima de impuesto aplicable respecto de un mismo capital: 0,8%”</li>
            </ol>
        </Paragraph>
    </InfoModal>
);

export default DecretoModalLey;
